import axios from 'axios'
import ApiService from '@/apis/apiService'

const api = new ApiService(axios, { })

export default api
